//#region types
import { FormEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { HoldingRegisterFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import useHoldingRegisterCommonFilterProps from "./useCommonFilterProps";
//#endregion

function useAssetsReportFilterDefinition() {
  const {
    generalFilterFormFields,
    dateFilterFormFields,
    filterQueryStateHandler: baseFilterQueryStateHandler,
  } = useHoldingRegisterCommonFilterProps();

  const filterFormFields: GenericFormSection<HoldingRegisterFormTypes.HoldingRegisterAssetsFilter>[] = [
    {
      label: TranslationKeys.Common.Dates,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: dateFilterFormFields,
    },
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: generalFilterFormFields,
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<HoldingRegisterFormTypes.HoldingRegisterAssetsFilter> =
    baseFilterQueryStateHandler;

  return {
    filterFormFields,
    filterQueryStateHandler,
  };
}

export default useAssetsReportFilterDefinition;
